import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import format from "date-fns/format";
import { exportToExcel } from "../utils/utils";
import { errorSnackbar } from "../redux/features/customSnackbar/action";
import {
  getTicketURL,
  transformApiDataToRows,
  VIEW_TYPE,
} from "../utils/ticketUtils";
import { API } from "../apis/api";


const fetchTickets = async (startDate, endDate, ticketStatus, viewType, userId) => {
  try {
    const fromDate = startDate || "2024-06-05T05:30:00Z";
    const toDate = endDate || "2025-07-29T23:59:59Z";

    const apiUrl = getTicketURL(viewType);

    const requestBody = {
      ticket_status: ticketStatus,
      from_datetime: fromDate,
      to_datetime: toDate,
      limit: 10000,
      offset: 0,
      sub:userId,
    };

    const response = await API.post(apiUrl, requestBody);
    return response.data;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error;
  }
};

const useTicketExport = (
  ticketStatus,
  columns,
  viewType = VIEW_TYPE.ASSIGNED
) => {
  const [isExporting, setIsExporting] = useState(false);
  const dispatch = useDispatch();
  const userId= useSelector((state)=>state.auth.user.userId)

  const handleExport = async (from, to) => {
    setIsExporting(true);
    try {
      const formattedFrom = from.toISOString();
      const formattedTo = to.toISOString();


      const apiData = await fetchTickets(
        formattedFrom,
        formattedTo,
        ticketStatus,
        viewType,
        userId,
      );

      const transformedRows = transformApiDataToRows(apiData);

      if (!transformedRows.length) {
        dispatch(
          errorSnackbar({
            title: "Export: No data found",
            subtitle: "",
            duration: 5000,
          })
        );
        return;
      }

      const filteredColumn = columns.filter((col)=>(
        col.field !== "remark" && col.title !== "Remark"
      ))

      const formatted = `${format(from, "yyyyMMdd")}_${format(to, "yyyyMMdd")}`;
      exportToExcel(
        transformedRows,
        filteredColumn,
        `${ticketStatus}_Tickets_${formatted}`
      );
      
    } catch (error) {
      console.error("Export failed:", error);
      dispatch(
        errorSnackbar({
          title: "Export Failed",
          subtitle: "An error occurred while exporting tickets",
          duration: 5000,
        })
      );
    } finally {
      setIsExporting(false);
    }
  };

  return { handleExport, isExporting };
};

export default useTicketExport;
